<app-basic-card [css]="'mb-3'">
    <h5>Documenti</h5>
    <mat-tab-group animationDuration="500ms" mat-stretch-tabs="false" mat-align-tabs="start" class="mt-3">
        <mat-tab *ngFor="let documentConfig of documentConfigs">
            <ng-template mat-tab-label>
                <img [src]="documentConfig.logo" class="company-logo" alt="company-logo"/>
            </ng-template>
            <ng-container *ngIf="documentConfig.documents && documentConfig.documents.length > 0">
                <div class="mt-3 mb-3">
                    <div class="d-flex justify-content-center align-items-center" >
                        <table aria-label="documents-table" class="table mt-3">
                            <thead class="bg-light">
                                <tr>
                                    <th scope="col">Descrizione</th>
                                    <th scope="col">Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let document of documentConfig.documents">
                                    <tr>
                                        <td>
                                            <h6>{{ document.name }}</h6>
                                        </td>
                                        <td class="fixed-width">
                                            <mat-icon 
                                                class="download-icon" 
                                                aria-hidden="false" 
                                                aria fontIcon="download" 
                                                (click)="onActionRequested(document)" 
                                                *ngIf="document.preSignedUrl"
                                            ></mat-icon>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>
            </ng-container>
        </mat-tab>
    </mat-tab-group>
</app-basic-card>